{"BASE_URL":"/","DEV":false,"PROD":true,"MODE":"production"}